
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'show',
    standalone: false
})
export class ShowPipe implements PipeTransform {
  transform(value: any, show: boolean): any[] {
    if (!show) {
      return null;
    }
    return value;
  }
}
